import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start with 23h 27m 35s in seconds
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 27 * 60 + 35);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center my-8" data-id="element-79">
      <div className="flex items-center gap-2 text-brand-gold mb-4 font-bold tracking-wider text-sm" data-id="element-80">
        <Clock className="w-4 h-4" data-id="element-81" />
        <span data-id="element-82">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
      </div>

      <div className="flex gap-4 text-center" data-id="element-83">
        <div className="flex flex-col" data-id="element-84">
          <motion.div key={hours} initial={{
          y: -10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} className="bg-brand-card border border-brand-gold/30 text-white text-3xl md:text-5xl font-bold w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl shadow-[0_0_15px_rgba(212,160,23,0.1)]" data-id="element-85">
            {format(hours)}
          </motion.div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest" data-id="element-86">
            Horas
          </span>
        </div>
        <div className="text-3xl md:text-5xl font-bold text-brand-gold/50 mt-2" data-id="element-87">
          :
        </div>
        <div className="flex flex-col" data-id="element-88">
          <motion.div key={minutes} initial={{
          y: -10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} className="bg-brand-card border border-brand-gold/30 text-white text-3xl md:text-5xl font-bold w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl shadow-[0_0_15px_rgba(212,160,23,0.1)]" data-id="element-89">
            {format(minutes)}
          </motion.div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest" data-id="element-90">
            Min
          </span>
        </div>
        <div className="text-3xl md:text-5xl font-bold text-brand-gold/50 mt-2" data-id="element-91">
          :
        </div>
        <div className="flex flex-col" data-id="element-92">
          <motion.div key={seconds} initial={{
          y: -10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} className="bg-brand-card border border-brand-gold/30 text-brand-gold text-3xl md:text-5xl font-bold w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl shadow-[0_0_15px_rgba(212,160,23,0.2)]" data-id="element-93">
            {format(seconds)}
          </motion.div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest" data-id="element-94">
            Seg
          </span>
        </div>
      </div>

      <div className="mt-6 text-red-400 text-sm font-medium flex items-center gap-2 bg-red-500/10 px-4 py-2 rounded-full" data-id="element-95">
        <span data-id="element-96">⚠️</span> Después sube $5.000 ARS. No vuelve.
      </div>
    </div>;
}